<template>
  <div id="page-onboarding" class="processes d-flex" v-if="report">
    <MainBarMenu />

    <div class="layout-content container-fluid">
      <div class="row">
        <div class="col-md-6 pt-4">
          <h2 class="mb-4">REPORTE DISCIPLINARIO - RD{{ report.id }}</h2>
          <div class="row process-info mx-1 mb-5">
            <div class="col-md-3 p-2">
              <span class="icon icon-info mx-1"></span>
              INFORMACIÓN
            </div>
            <div class="col-md-5 p-2">
              <span class="mx-2"></span>
              <span class="icon icon-calendario mx-1"></span>
              Fecha inicio: {{ formatDate(report.date_knowledge) }}
            </div>
            <div class="col-md-4 p-2">
              <span class="icon icon-place mx-1"></span>
              Cervecería Tocancipá {{ report.site }}
            </div>
          </div>
          <div class="alert alert-warning text-center mb-4">
            <div>
                El <span class="font-weight-bold">copy</span> de creación del reporte nuevo va acá
            </div>
          </div>
          <template>
            <div class="accordion mx-auto" role="tablist">
              <b-card no-body class="mb-4">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-1>
                    <span class="mx-4"></span>
                    Datos generales del reporte
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td>Coordinador</td>
                          <td width="20"></td>
                          <td width="55%" class="text-left">
                            <span>{{ report.coordinator_detail.name }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Fecha de conocimiento de la falta</td>
                          <td width="30"></td>
                          <td class="text-left date">
                            <span>{{ formatDate(report.date_knowledge) }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Fecha de la presunta falta</td>
                          <td width="30"></td>
                          <td class="text-left date">
                            <span>{{
                              formatDate(report.data_alleged_failure)
                            }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Prioridad</td>
                          <td width="20"></td>
                          <td class="text-left">
                            <span v-if="report.util_priority_id === 11"
                              >Baja</span
                            >
                            <span v-if="report.util_priority_id === 12"
                              >Media</span
                            >

                            <span v-if="report.util_priority_id === 13"
                              >Alta</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Personas asociadas al reporte</td>
                          <td width="20"></td>
                          <td class="text-left">
                            <table class="n-padding w-100" border="1">
                              <thead>
                                <tr>
                                  <td>Nombre</td>
                                  <td>ID Sharp</td>
                                  <td>Site</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="employee in report.proce_employees"
                                  :key="employee.id"
                                >
                                  <td>{{ employee.core_employee.name }}</td>
                                  <td>{{ employee.core_employee.sharp_id }}</td>
                                  <td>
                                    {{ employee.core_employee.site.name }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-4">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-2>
                    <span class="mx-4"></span>
                    Soportes
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td valign="top">
                            <p
                              v-if="
                                user.core_role_id == '2' ||
                                user.core_role_id == '4'
                              "
                            >
                              Solicitar soporte adicional
                            </p>
                            <p v-else>Mensajes business partner</p>
                            <small
                              class="link-history"
                              @click="$bvModal.show('modalHistory')"
                              >Ver historial</small
                            >

                            <b-modal
                              id="modalHistory"
                              scrollable
                              hide-footer
                              title="Historial de soportes adicionales"
                              class="modalHistory"
                            >
                              <table class="formTable w-100 mx-auto text-right">
                                <tr>
                                  <td class="text-left">
                                    <div class="border-gray">
                                      <table
                                        class="n-padding w-100 no-border"
                                        border="1"
                                      >
                                        <thead>
                                          <tr>
                                            <td>Solicitado por</td>
                                            <td>Fecha</td>
                                            <td>Comentario</td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            v-for="evidenceReq in report.proce_request_evidences"
                                            :key="evidenceReq.id"
                                          >
                                            <td>
                                              {{
                                                evidenceReq.core_employee.name
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatDate(
                                                  evidenceReq.created_at
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{ evidenceReq.text }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </b-modal>
                          </td>
                          <td width="20"></td>
                          <td class="text-left">
                            <div class="form-group">
                              <textarea
                                class="form-control border-gray"
                                rows="4"
                                placeholder="Detalla el tipo de soporte que necesitas..."
                                v-model="reqEvidence"
                              ></textarea>
                            </div>
                            <small
                              v-if="
                                user.core_role_id == '2' ||
                                user.core_role_id == '4'
                              "
                            >
                              Coordinador:
                              {{ report.coordinator_detail.name }}</small
                            >
                            <button
                              class="btn btn-dark float-right"
                              @click="saveReqEvidence"
                              :disabled="reqEvidence == ''"
                            >
                              Enviar
                            </button>
                          </td>
                        </tr>
                      </table>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div
                              v-bind:class="
                                process.id == 0 ? 'border-gray' : ''
                              "
                            >
                              <table
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="evidence in report.proce_evidences"
                                    :key="evidence.id"
                                  >
                                    <td>{{ evidence.name }}</td>
                                    <td>{{ user.name }}</td>
                                    <td>
                                      {{ formatDate(evidence.created_at) }}
                                    </td>
                                    <td class="text-center">
                                      <a
                                        :href="serverPath + '/' + evidence.file"
                                        target="_blank"
                                      >
                                        <span
                                          class="icon icon-eye-2 mx-2"
                                        ></span>
                                      </a>
                                      <a
                                        :href="
                                          serverPath +
                                          '/api/v1/proceReports/file/download?file=' +
                                          evidence.file
                                        "
                                      >
                                        <span
                                          class="icon icon-descargar mx-2"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              v-bind:class="
                                process.id == 0 ? 'text-right' : 'text-center'
                              "
                            >
                              <label
                                :class="
                                  process.id == 0
                                    ? 'add-to-list btn'
                                    : 'btn add-to-list-2'
                                "
                              >
                                <input type="file" @change="selectFile" />
                                Añadir soporte
                              </label>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-4">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-3>
                    <span class="mx-4"></span>
                    Personas asociadas al reporte
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td>
                            <table
                              class="n-padding w-100 no-border text-left"
                              border="1"
                            >
                              <thead>
                                <tr>
                                  <td>Nombre</td>
                                  <td>ID Sharp</td>
                                  <td>Site</td>
                                  <td>Proceso</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="employee in report.proce_employees"
                                  :key="employee.id"
                                >
                                  <td>{{ employee.core_employee.name }}</td>
                                  <td>{{ employee.core_employee.sharp_id }}</td>
                                  <td>
                                    {{ employee.core_employee.site.name }}
                                  </td>
                                  <td>
                                    {{ employee.general_state.value }}
                                    <a
                                      class="link-action mx-2"
                                      @click="
                                        redirectToProcess(report.id, employee)
                                      "
                                      >{{employee.general_state.id === 21 ? "Iniciar": "Ver"}}</a
                                    >
                                    
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <div
                              v-if="user.core_role_id == '2'"
                              class="well-process m-4 mt-5"
                            >
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="requestConcept"
                                v-model="requestConcept"
                                @change="updateProcess"
                                :disabled="requestConcept"
                              />
                              <label
                                class="ml-2 form-check-label"
                                for="requestConcept"
                                >Solicitar concepto de relaciones
                                laborales:</label
                              >
                            </div>
                            <div
                              v-if="
                                user.core_role_id == '4' && isRequestConcept
                              "
                            >
                              <div class="alert-concept m-1 mt-5">
                                <span
                                  >El Business Partner solicitó tu concepto
                                  sobre este proceso:</span
                                >
                              </div>
                              <table
                                class="table n-padding w-100 no-border text-left no-border-table mt-4"
                              >
                                <tbody class="no-border-table">
                                  <tr
                                    class="no-border-table"
                                    v-for="employee in report.proce_employees"
                                    :key="employee.id"
                                  >
                                    <td class="no-border-table">
                                      {{ employee.core_employee.name }}
                                    </td>
                                    <td class="no-border-table">
                                      <div
                                        class="form-check form-check-inline mx-4"
                                      >
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          :name="'radioOption' + employee.id"
                                          :id="'radioOption1' + employee.id"
                                          value="1"
                                          :checked="employee.summon == 1"
                                          :disabled="employee.summon"
                                          @change="
                                            updateProcess2(employee.id, $event)
                                          "
                                        />
                                        <label
                                          class="form-check-label"
                                          :for="'radioOption1' + employee.id"
                                          >Citar</label
                                        >
                                      </div>
                                    </td>
                                    <td class="no-border-table">
                                      <div
                                        class="form-check form-check-inline mx-4"
                                      >
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          :name="'radioOption' + employee.id"
                                          :id="'radioOption2' + employee.id"
                                          value="0"
                                          :checked="employee.summon == 0"
                                          :disabled="employee.summon"
                                          @change="
                                            updateProcess2(employee.id, $event)
                                          "
                                        />
                                        <label
                                          class="form-check-label"
                                          :for="'radioOption2' + employee.id"
                                          >No citar</label
                                        >
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <!--div
                                v-for="employee in report.proce_employees"
                                :key="employee.id"
                                class="text-center mt-3"
                              >
                                {{ employee.core_employee.name }}

                                <div class="form-check form-check-inline mx-4">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    :name="'radioOption' + employee.id"
                                    :id="'radioOption1' + employee.id"
                                    value="1"
                                    :checked="employee.summon == 1"
                                    :disabled="employee.summon"
                                    @change="
                                      updateProcess2(employee.id, $event)
                                    "
                                  />
                                  <label
                                    class="form-check-label"
                                    :for="'radioOption1' + employee.id"
                                    >Citar</label
                                  >
                                </div>
                                <div class="form-check form-check-inline mx-4">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    :name="'radioOption' + employee.id"
                                    :id="'radioOption2' + employee.id"
                                    value="0"
                                    :checked="employee.summon == 0"
                                    :disabled="employee.summon"
                                    @change="
                                      updateProcess2(employee.id, $event)
                                    "
                                  />
                                  <label
                                    class="form-check-label"
                                    :for="'radioOption2' + employee.id"
                                    >No citar</label
                                  >
                                </div>
                              </div-->
                            </div>
                            <div
                              v-if="user.core_role_id != '4' && requestConcept"
                              class="well-process m-4 mt-5"
                            >
                              <div class="mb-3">
                                Concepto de relaciones laborales:
                              </div>
                              <p
                                v-for="employee in report.proce_employees"
                                :key="employee.id"
                              >
                                <span class="font-weight-bold"
                                  >{{ employee.core_employee.name }}:</span
                                >
                                <span v-if="employee.summon == 1">
                                  Iniciar proceso disciplinario
                                </span>
                                <span v-else-if="employee.summon == 0">
                                  Cerrar proceso disciplinario
                                </span>
                                <span v-else> Pendiente </span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </template>
        </div>
        <div class="col-md-6 pt-3 border-left">
          <div class="tab">Reporte</div>
          <Editor v-model="report.letter" disabled></Editor>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import Editor from "@/components/general/Editor.vue";
import { mapState, mapActions } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "ProcessDetail",
  components: {
    MainBarMenu,
    Editor,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      reqEvidence: "",
      employeeSearch: "",
      employeesCoordinator: [],
      listEmployeesCoordinator: [],
      selectedEmployees: [],
      error: {
        flag: false,
        class: "",
        message: "",
      },
      msjModal: "",
      selectedFiles: [],
      requestConcept: undefined,
    };
  },
  async created() {
    await this.actGetReport(this.$route.params.id);
  },
  updated() {
    let employeeReqSummon = this.report.proce_employees.filter(
      (employee) => employee.summon_labor_relations == 1
    );
    if (employeeReqSummon.length > 0) {
      this.requestConcept = true;
    }
  },

  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modProcesses", ["process", "report"]),
    isRequestConcept() {
      let employeeReqSummon = this.report.proce_employees.filter(
        (employee) => employee.summon_labor_relations == 1
      );
      if (employeeReqSummon.length > 0) {
        return true;
      }
      return false;
    },
  },

  methods: {
    ...mapActions("modCore", ["actUser", "actBP"]),
    ...mapActions("modProcesses", [
      "actGetReport",
      "actSaveReportEvidence",
      "actSaveRequestEvidence",
      "actUpdateProcessEmployee",
    ]),
    selectFile() {
      this.selectedFiles = [];
      this.selectedFiles.push(event.target.files[0]);
      this.uploadFiles();
    },
    async uploadFiles() {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        await this.upload(i, this.selectedFiles[i]);
      }
    },

    async upload(idx, file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("proce_report_id", this.report.id);
      await this.actSaveReportEvidence(formData);
      return true;
    },
    async updateProcess() {
      for (let i = 0; i < this.report.proce_employees.length; i++) {
        await this.actUpdateProcessEmployee({
          id: this.report.proce_employees[i].id,
          summon_labor_relations: (+this.requestConcept).toString(),
        });
      }
    },
    async updateProcess2(id, event) {
      await this.actUpdateProcessEmployee({
        id: id,
        summon: event.target.value.toString(),
      });
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
        const mo = new Intl.DateTimeFormat("es", { month: "short" })
          .format(d)
          .replace(".", "");
        const da = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(d);
        return `${da} ${mo.charAt(0).toUpperCase() + mo.slice(1)}, ${ye}`;
      } else {
        return "";
      }
    },
    redirectToProcess(report, process) {
      if (this.user.core_role_id == "2") {
        this.$router.push("/process/" + report + "/" + process.id);
      } else if (process.proce_state_id > 1) {
        this.$router.push("/process/" + report + "/" + process.id);
      } else {
        return false;
      }
    },
    async saveReqEvidence() {
      if (this.reqEvidence) {
        await this.actSaveRequestEvidence({
          proce_report_id: this.report.id,
          text: this.reqEvidence,
        });
        this.reqEvidence = "";
      }
      return true;
    },
  },
};
</script>
<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 20px;
  margin-bottom: 5px;
  width: 100px;
  height: 28px;
  background: rgba(28, 103, 118, 0.45);
  border-radius: 5px 5px 0px 0px;
}

input[type="file"] {
  opacity: 0;
  filter: alpha(opacity=0);
  display: block;
  width: 360px;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.alert-concept {
  text-align: center;
  padding: 10px 0;
  background: #fff3cd;
  border-radius: 4px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #816208;
}

.link-action {
  cursor: pointer;
  text-decoration: underline;
  color: #779B49;
}

.link-history {
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
}

.modal-body table {
  border-radius: 5px;
}

.modal-body table thead {
  color: #1c3a4e;
  font-size: 14px;
  font-weight: normal;
}

.modal-body table tbody {
  font-size: 12px !important;
  color: #4e565c;
}

.modal-body table tbody td a {
  color: #4e565c;
}

.modal-body table thead td {
  color: #4e565c;
}

.modal-body .formTable td {
  padding: 10px 0 10px 0;
}

.modal-body .n-padding td {
  padding: 0px 0 0px 10px;
}

.modal-body .border-gray {
  border: #bbbbbb 2px solid;
  border-radius: 4px;
  padding: 1px 4px 0px 4px;
}

.modal-body .no-border {
  border: none;
}

.modal-body .formTable table {
  margin-top: -2px;
  margin-bottom: -1px;
}

.modal-body .formTable table tr td {
  border: #ddd 1px solid;
  border-radius: 5px;
}
.modal-body .formTable table tr td:first-child {
  border-left: none;
}
.modal-body .formTable table tr td:last-child {
  border-right: none;
}

.no-border-table {
  border: hidden !important;
  border-color: #fff !important;
}
</style>
